module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "id": "open-or-close"
    }
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-red",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openOrCloseDoor('open')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("button.open")) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-red",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openOrCloseDoor('close')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("button.close")) + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1955d6de"}!./src/app/pages/rentals/open-or-close-rental-door/open-or-close-rental-door.html
// module id = 1306
// module chunks = 0